import React from 'react';

import { IndexRoute, Route } from 'react-router';

import FourOhFour from 'common/routeComponents/general/FourOhFour';

import CreateJob from './CreateJob';
import EditJob from './EditJob';
import Job from './Job';
import JobContainer from './JobContainer';
import JobsContainer from './JobsContainer';
import JobsHome from './JobsHome';

export default (
  <Route path="/" component={JobsContainer}>
    <IndexRoute component={JobsHome} />

    <Route path="create" component={CreateJob} />

    <Route path=":department/:jobURLName" component={JobContainer}>
      <IndexRoute component={Job} />

      <Route path="edit" component={EditJob} />
    </Route>

    {/* 404 */}
    <Route path="*" component={FourOhFour} />
  </Route>
);
